import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'antd';
import styles from '../pages/login.module.scss';
import { ADMIN_PIN_LENGTH } from '../../admins/utils/adminUsername';

// PIN od 5 cifara kao zasebna polja (antd Input.OTP), maskirano, samo cifre.
// onInput (ne onChange): onChange okida tek kad su sva polja popunjena, pa
// brisanje cifre ne bi stiglo do stanja. Polje je nekontrolisano; `resetKey`
// promenom ga prazni (npr. posle neuspesne prijave).
const PinInput = ({ labelId, onChange, resetKey }) => (
  <Input.OTP
    key={resetKey}
    className={styles.login__pin}
    length={ADMIN_PIN_LENGTH}
    mask="•"
    inputMode="numeric"
    aria-labelledby={labelId}
    formatter={(value) => value.replace(/[^\d ]/g, '')}
    onInput={(cells) => onChange(cells.join('').replace(/\D/g, ''))}
  />
);

PinInput.propTypes = {
  labelId: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  resetKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default PinInput;
